<template>
  <div class="border rounded">
    <table class="table table-sm table-hover w-100">
      <thead>
        <tr>
          <th class="text-center" colspan="2">
            Order
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center" colspan="2">
            <strong>Return</strong>
          </td>
        </tr>
        <!-- <tr>
          <td class="text-right w-35">
            <strong>Call tag num:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.callTag"
            />
          </td>
        </tr> -->
        <!-- <tr>
          <td class="text-right w-35">
            <strong>Label requested:</strong>
          </td>
          <td class="text-left w-65">
            <b-form-checkbox v-model="order.labelReq" switch />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Date required:</strong>
          </td>
          <td class="text-left w-65"> -->
            <!-- <input
              class="form-control"
              type="date"
              name=""
              id=""
              v-model="order.labelReqDate"
            /> -->
            <!-- <a-date-picker
              style="width: 100%;"
              format="MM/DD/YYYY"
              :value="order.labelReqDate"
              @change="updateLabelReqDate"
              id="dateFrom"
            />
          </td>
        </tr> -->
        <!-- <tr>
          <td class="text-right w-35">
            <strong>Replacement request:</strong>
          </td>
          <td class="text-left w-65">
            <b-form-checkbox v-model="order.replaceReq" switch />
          </td>
        </tr> -->
        <!-- <tr>
          <td class="text-right w-35">
            <strong>Return points:</strong>
          </td>
          <td class="text-left w-65">
            <b-form-checkbox v-model="order.ret_points" switch />
          </td>
        </tr> -->
        <tr>
          <td class="label-cell w-35">
            <strong>Returned by:</strong>
          </td>
          <td class="value-cell w-65">
            <span>{{ order.ret_by_name }}</span>
          </td>
        </tr>
        <tr>
          <td class="label-cell w-35">
            <strong>Return Reason:</strong>
          </td>
          <td class="value-cell w-65">
            <select class="form-control input-sm" v-model="selectedReason">
              <option value="-1">Other (Enter Reason)</option>
              <option value="Defective">Defective</option>
              <option value="Wrong Item Sent">Wrong Item Sent</option>
              <option value="Damaged">Damaged</option>
              <option value="Poor Quality">Poor Quality</option>
              <option value="Changed Mind">Changed Mind</option>
              <option value="No longer available">No longer available</option>
            </select>

            <input
              v-if="selectedReason === '-1'"
              class="form-control mt-2"
              type="text"
              placeholder="Enter return reason"
              v-model="order.ret_reason"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "OrderStatus",
  data() {
    return {
      selectedReason: "-1",
    };
  },
  watch: {
    order: {
      immediate: true,
      handler(val) {
        if (val && !val.ret_by_name) {
          const username = localStorage.getItem("loginUsername");
          if (username) {
            this.order.ret_by_name = username;
          }
        }
      }
    },
    selectedReason(val) {
      if (val !== "-1") {
        this.order.ret_reason = val;
      } else {
        this.order.ret_reason = "";
      }
    }
  },
  mounted() {
    const username = localStorage.getItem("loginUsername");
    if (username && !this.order.ret_by_name) {
      this.order.ret_by_name = username;
    }
  },
  methods: {
    updateLabelReqDate(date, datestring) {
      this.order.labelReqDate = datestring;
    },
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
};
</script>

<style lang="scss" scoped>
  td {
    border: solid grey 0.5px;
    vertical-align: middle;
  }

  .value-cell {
    text-align: center;
    vertical-align: middle;
  }

  .value-cell span {
    display: block;
    width: 100%;
    text-align: center;
    font-weight: 500;
  }

  .value-cell select,
  .value-cell input {
    margin-left: auto;
    margin-right: auto;
    display: block;
    max-width: 220px;
  }

  .label-cell {
    text-align: right;
    vertical-align: middle;
  }

</style>
